<script setup lang="ts">
withDefaults(defineProps<{ url?: string }>(), {
    url: 'https://liberty.eu/bez-abonamentu/telefony',
})

const emits = defineEmits(['close'])

const { sendMenuEvent } = useSendEvent()

function cameBackToMainPage() {
    emits('close')
    sendMenuEvent('Wróć do strony plus.pl')
}
</script>

<template>
    <PlusBlogLpOrganismDialog>
        <PlusBlogLpOrganismDialogTrigger
            v-if="$slots.trigger"
            as-child
        >
            <slot name="trigger" />
        </PlusBlogLpOrganismDialogTrigger>
        <PlusBlogLpOrganismDialogContent
            class="max-w-[calc(100vw-32px)] rounded-2xl px-6 py-8 sm:max-w-[600px] lg:p-12"
        >
            <img
                class="h-5 w-auto md:h-[unset]"
                src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/menu/liberty-logo.webp"
                alt="liberty"
            />
            <p class="text-paragraph-lg">Sprzedaż telefonów za gotówkę realizuje nasz partner, sklep Liberty</p>
            <div class="mt-6 items-center gap-4 md:mt-14 md:flex">
                <PlusBlogLpAtomDialogClose
                    class="mb-4 w-full basis-1/2 md:mb-0"
                    tabindex="-1"
                >
                    <PlusBlogLpAtomBaseButton
                        block
                        variant="secondary"
                        @click="cameBackToMainPage"
                    >
                        Wróć do strony plus.pl
                    </PlusBlogLpAtomBaseButton>
                </PlusBlogLpAtomDialogClose>
                <PlusBlogLpAtomBaseButton
                    class="basis-1/2 text-center"
                    block
                    arrow
                    :to="url"
                    @click="sendMenuEvent('Przejdź na liberty.pl', url)"
                >
                    Przejdź na liberty.pl
                </PlusBlogLpAtomBaseButton>
            </div>
        </PlusBlogLpOrganismDialogContent>
    </PlusBlogLpOrganismDialog>
</template>
